module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2>Wunderground Settings</h2>\n	<table>\n		<tr>\n			<th>API</th>\n			<td>\n				<input type=\'text\' class=\'field\' id=\'options.API\' value=\''+
((__t=(options.API))==null?'':__t)+
'\'>\n			</td>\n		</tr>\n	</table>\n';
}
return __p;
};
